// @flow
import {Text} from 'componentsStyled/Typography/Texts';
import styled from 'styled-components';

export const Group = styled.div`
  margin-top: 3rem;
`;

export const Item = styled(Text)`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
export const IconWrap = styled.span`
  svg {
    margin-right: 1rem;
  }
`;

export const CountryTitle = styled(Text)`
  padding: 0 1.6rem;
`;

export const StyledSortButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 1.6rem;
  gap: 1rem;
  border: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
